import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'

const STATUS_CONFIG = {
  pending: { label: 'Pending', className: 'bg-amber-100 text-amber-800 border-amber-200' },
  confirmed: { label: 'Confirmed', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  delivered: { label: 'Delivered', className: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  invoiced: { label: 'Invoiced', className: 'bg-green-100 text-green-800 border-green-200' },
  paid: { label: 'Paid', className: 'bg-slate-100 text-slate-800 border-slate-200' }
}

export default function QuickOrderCard({ order, onClick }) {
  const status = STATUS_CONFIG[order.status] || STATUS_CONFIG.pending

  // Calculate total from sale_items
  const total = order.sale_items?.reduce((sum, item) => {
    return sum + (item.quantity * item.price)
  }, 0) || 0

  const itemCount = order.sale_items?.filter(i => i.quantity > 0).length || 0

  return (
    <button
      onClick={() => onClick(order)}
      className={cn(
        'w-full text-left px-4 py-3 hover:bg-accent/50 transition-colors',
        'active:bg-accent/70',
        'border-b last:border-b-0'
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="font-medium text-sm truncate">
            {order.customer?.name || 'Unknown Customer'}
          </p>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-muted-foreground">
              {itemCount} {itemCount === 1 ? 'item' : 'items'}
            </span>
            <Badge variant="outline" className={cn('text-[10px] px-1.5 py-0', status.className)}>
              {status.label}
            </Badge>
          </div>
        </div>
        <span className="font-semibold text-sm text-green-700 whitespace-nowrap">
          £{total.toFixed(2)}
        </span>
      </div>
    </button>
  )
}
